import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { queryFromHome } from '@app/_models/queryFromHome';
import { DisputeService } from '@app/_services/dispute.service';
import { LogService } from '@app/_shared/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {

  queryForm: FormGroup;
  submitted: boolean = false;
  queryModel = new queryFromHome();
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private formBuilder: FormBuilder,
    private disputeService: DisputeService,
    private SpinnerService: NgxSpinnerService,
    private eventService: LogService,
    private modalService: NgbModal,
    ) { }

  ngOnInit(): void {

    this.queryForm = this.formBuilder.group({
      emailid: ['', Validators.required],
      query: ['', Validators.required]
    });

  }

  get f() { return this.queryForm.controls; }

  sendQuery(){
    this.submitted = true;
    // this.SpinnerService.show();
  if(this.queryForm.invalid){
    return;
  }
  
    console.log("SEND QUERY", this.queryForm.value);

    this.disputeService.sendQueryFromHome(this.queryForm.value)
    .pipe(first())
    .subscribe(
      data => {
        this.SpinnerService.hide();
        console.log("response---", data);
        this.modalService.open(this.showModalBoxTemplate);
      },
      error => {
        console.log(error)

      },
    )

  }

  refresh(){
    location.reload();
  }

}
